import React from 'react';

import { useSearchParams } from 'src/hooks';
import { LayoutBoxProps } from 'src/kit';
import { DesktopPublicHeader, StandaloneFooter } from '@src/features/common';
import { MainLayout } from './MainLayout';

export type PublicLayoutProps = LayoutBoxProps & {
  header?: React.ReactNode;
  sidebar?: React.ElementType<any>;
  footer?: boolean;
  children: React.ReactNode;
};

export const PublicLayout = (props: PublicLayoutProps) => {
  const { standalone } = useSearchParams();
  const layoutProps = standalone ? { header: null, footer: <StandaloneFooter /> } : { header: <DesktopPublicHeader /> };

  return <MainLayout {...layoutProps} {...props} />;
};
